import { render } from "./SliderVideo.vue?vue&type=template&id=2290537e&scoped=true"
import script from "./SliderVideo.vue?vue&type=script&lang=js"
export * from "./SliderVideo.vue?vue&type=script&lang=js"

import "./SliderVideo.vue?vue&type=style&index=0&id=2290537e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2290537e"]])

export default __exports__